export default __webpack_public_path__ + "static/media/share.a767f6af.png";